// extracted by mini-css-extract-plugin
export var chevron = "_el-2";
export var dropdownItems = "_el-0";
export var item = "_el-1";